
<div id="timeViewComponentMain">
    <h2>Time</h2>
    <table id="timeViewComponentMain">
        <tr>
            <th>Device</th>
            <td>{{ localTime$ | async }}</td>
        </tr>
        <tr>
            <th>Adjusted</th>
            <td>{{ adjustedTime$ | async }}</td>
        </tr>
    </table>
</div>